export class HttpRequestAction {
  public static type: string = '[HTTP] Request';
  constructor(public request: any, public type: string) {}
}
